import { actionTypes } from './actions';

import initialState from './initialState';

export default function incomingDataReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET:
      return state.set('data', Object.assign({}, state.get('data'), action.payload));
    default:
      return state;
  }
}
